import { create } from 'zustand';

const useStore = create((set) => ({
  currentTask: '',
  response: null,
  loading: false,
  activeAgent: null,
  systemStatus: 'disconnected',
  agents: [],

  setCurrentTask: (task) => set({ currentTask: task }),
  setResponse: (response) => set({ response }),
  setLoading: (loading) => set({ loading }),
  setActiveAgent: (agent) => set({ activeAgent: agent }),
  setSystemStatus: (status) => set({ systemStatus: status }),
  setAgents: (agents) => set({ agents }),
}));

export default useStore;
